import {
  Box, DashboardModuleListItem, Image, StatusBadge, Text,
} from '@domain-group/suit-theme'

import useCampaignComparable, { useCampaignComparableImage } from '@hooks/useCampaignComparable'

import { CampaignComparableModel } from '@models/types'

import defaultImageUrl from '../../assets/default-comparable.png'

const getStatusText = (saleMethod: string, sold: boolean) => {
  if (saleMethod === 'rental') return 'For Rent'
  if (sold) return 'Sold'

  return 'For Sale'
}

interface CampaignComparableListItemProps {
  campaignComparable: CampaignComparableModel,
}

const CampaignComparableListItem = (props: CampaignComparableListItemProps) => {
  const { campaignComparable } = props

  const {
    address,
    bathrooms,
    bedrooms,
    carparks,
    price_guide,
    sale_method,
    sale_type,
    sold,
    suburb_name,
  } = campaignComparable

  const {
    callbacks: {
      createOrEditCampaignComparable,
    },
  } = useCampaignComparable(campaignComparable)

  const { imageUrl } = useCampaignComparableImage(campaignComparable)

  return (
    <DashboardModuleListItem
      imageComponent={(
        <Image
          borderRadius={5}
          boxProps={{ justifyContent: 'flex-state', alignItems: 'flex-end', padding: 'small' }}
          height={65}
          placeholderUrl={defaultImageUrl}
          url={imageUrl}
          width={100}
        />
      )}
      onClick={() => createOrEditCampaignComparable()}
      secondaryText={`${bedrooms || 0} Bed | ${bathrooms || 0} Bath | ${carparks || 0} Car`}
      title={`${address}, ${suburb_name}`}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        <Box flexDirection="column" alignItems="flex-end" marginRight="medium">
          <StatusBadge
            color={sold ? 'green' : 'blue'}
            text={getStatusText(sale_method, sold)}
          />

          <Text color="bodyFontLightColor" marginTop="small" fontSize="xsmall">
            {sale_type && `${sale_type}`}
            {sale_type && price_guide && ' - '}
            {price_guide && price_guide}
          </Text>
        </Box>
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default CampaignComparableListItem
